import { Tooltip as TooltipAntd } from "antd";
import { TooltipPropsWithTitle } from "antd/es/tooltip";
import { useIsDesktop } from "hooks/useDeviceType";
import { PropsWithChildren } from "react";
import { GlobalStore } from "store/global/GlobalStore";

export const Tooltip = ({
  children,
  ...tooltipProps
}: PropsWithChildren<TooltipPropsWithTitle>) => {
  const theme = GlobalStore.useState(s => s.theme);
  const isDesktop = useIsDesktop();

  return (
    <TooltipAntd
      placement="right"
      overlayStyle={{ zIndex: 100000000000 }}
      overlayInnerStyle={{
        color: theme.font.primary.default,
        font: theme[isDesktop ? "Desktop" : "Mobile"].Paragraph.Medium,
      }}
      {...tooltipProps}
    >
      {children}
    </TooltipAntd>
  );
};
